import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=5241de94&"
import script from "./ProductUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports